import { render, staticRenderFns } from "./PersonalIdCardModal.vue?vue&type=template&id=fa7c9ae2&scoped=true&"
import script from "./PersonalIdCardModal.vue?vue&type=script&lang=ts&"
export * from "./PersonalIdCardModal.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalIdCardModal.vue?vue&type=style&index=0&id=fa7c9ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c9ae2",
  null
  
)

export default component.exports